
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function ServicesPage() {
  const services = [
    {
      id: 'personales',
      icon: 'ri-user-fill',
      title: 'Créditos Personales',
      subtitle: 'Financiamiento para tus proyectos personales',
      description: 'Solución financiera diseñada para personas que buscan capital para proyectos personales, consolidación de deudas, educación, salud o cualquier necesidad específica.',
      image: 'https://public.readdy.ai/ai/img_res/2217f154dc43ecd5fc021b0feb59f185.jpg',
      profile: 'Personas mayores de 21 años con ingresos demostrables y buen historial crediticio',
      amounts: 'Desde $1,000 hasta $50,000 USD',
      terms: 'Plazos flexibles de 12 a 60 meses',
      rate: 'Tasas competitivas desde 12% anual',
      requirements: [
        'Identificación oficial vigente',
        'Comprobante de domicilio reciente',
        'Comprobantes de ingresos (últimos 3 meses)',
        'Estado de cuenta bancario',
        'Referencias personales'
      ],
      process: [
        'Solicitud en línea (10 minutos)',
        'Evaluación crediticia (24-48 horas)',
        'Aprobación y firma digital',
        'Desembolso en tu cuenta (24 horas)'
      ]
    },
    {
      id: 'microcreditos',
      icon: 'ri-flashlight-fill',
      title: 'Microcréditos Rápidos',
      subtitle: 'Soluciones ágiles para necesidades inmediatas',
      description: 'Financiamiento express con proceso simplificado, ideal para cubrir gastos urgentes o aprovechar oportunidades de negocio que requieren respuesta inmediata.',
      image: 'https://readdy.ai/api/search-image?query=Small%20business%20owner%20receiving%20quick%20microcredit%20approval%20on%20smartphone%2C%20modern%20financial%20technology%20interface%2C%20fast%20and%20efficient%20service%20concept%2C%20clean%20simple%20background%20with%20emerald%20green%20accents%2C%20professional%20photography%20showing%20speed%20and%20accessibility%20in%20microfinance%20solutions&width=800&height=500&seq=service-detail-micro&orientation=landscape',
      profile: 'Personas con necesidades financieras inmediatas y capacidad de pago a corto plazo',
      amounts: 'Desde $500 hasta $5,000 USD',
      terms: 'Plazos de 3 a 12 meses',
      rate: 'Tasas desde 15% anual',
      requirements: [
        'Identificación oficial',
        'Comprobante de domicilio',
        'Comprobante de ingresos básico',
        'Número telefónico activo'
      ],
      process: [
        'Solicitud express en línea (5 minutos)',
        'Evaluación automatizada (2-4 horas)',
        'Aprobación inmediata',
        'Desembolso el mismo día'
      ]
    },
    {
      id: 'empresarial',
      icon: 'ri-building-fill',
      title: 'Financiamiento Empresarial',
      subtitle: 'Capital para el crecimiento de tu negocio',
      description: 'Soluciones de financiamiento diseñadas para pequeñas y medianas empresas que buscan capital de trabajo, expansión, adquisición de equipos o desarrollo de nuevos proyectos.',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20business%20meeting%20discussing%20company%20financing%20and%20growth%20strategy%2C%20professional%20executives%20reviewing%20business%20expansion%20plans%2C%20modern%20conference%20room%20with%20financial%20charts%2C%20sophisticated%20corporate%20environment%20with%20emerald%20and%20slate%20tones%2C%20high-end%20business%20photography&width=800&height=500&seq=service-detail-business&orientation=landscape',
      profile: 'PyMEs con al menos 2 años de operación y estados financieros auditables',
      amounts: 'Desde $10,000 hasta $500,000 USD',
      terms: 'Plazos de 12 hasta 84 meses',
      rate: 'Tasas preferenciales desde 10% anual',
      requirements: [
        'Acta constitutiva de la empresa',
        'Estados financieros (últimos 2 años)',
        'Declaraciones fiscales',
        'Identificación de representante legal',
        'Plan de negocios o proyecto de inversión'
      ],
      process: [
        'Solicitud y envío de documentación',
        'Análisis financiero especializado (3-5 días)',
        'Visita de evaluación (opcional)',
        'Aprobación y firma de contrato',
        'Desembolso según calendario acordado'
      ]
    },
    {
      id: 'hipotecario',
      icon: 'ri-home-fill',
      title: 'Créditos Hipotecarios',
      subtitle: 'Financia la casa de tus sueños',
      description: 'Financiamiento para adquisición de vivienda nueva o usada, con tasas competitivas y plazos extendidos que se ajustan a tu capacidad de pago.',
      image: 'https://readdy.ai/api/search-image?query=Happy%20family%20receiving%20house%20keys%20from%20real%20estate%20agent%2C%20modern%20residential%20property%20in%20background%2C%20professional%20mortgage%20approval%20moment%2C%20clean%20architectural%20setting%20with%20natural%20light%2C%20emerald%20and%20slate%20color%20palette%2C%20corporate%20real%20estate%20photography%20showing%20trust%20and%20achievement&width=800&height=500&seq=service-detail-mortgage&orientation=landscape',
      profile: 'Personas con ingresos estables que buscan adquirir vivienda propia',
      amounts: 'Hasta el 80% del valor de la propiedad',
      terms: 'Plazos de 5 hasta 30 años',
      rate: 'Tasas fijas o variables desde 8% anual',
      requirements: [
        'Identificación oficial vigente',
        'Comprobantes de ingresos (últimos 6 meses)',
        'Avalúo de la propiedad',
        'Escrituras del inmueble',
        'Historial crediticio favorable',
        'Enganche mínimo del 20%'
      ],
      process: [
        'Precalificación en línea',
        'Evaluación crediticia completa (5-7 días)',
        'Avalúo de la propiedad',
        'Aprobación final',
        'Firma ante notario',
        'Desembolso y escrituración'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold text-slate-800 mb-6">
              Nuestros Servicios
            </h1>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
              Soluciones financieras profesionales adaptadas a cada necesidad
            </p>
          </div>

          <div className="space-y-24">
            {services.map((service, index) => (
              <div key={service.id} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <div className="w-full h-96 rounded-2xl overflow-hidden shadow-lg">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
                
                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                    <i className={`${service.icon} text-white text-3xl`}></i>
                  </div>
                  <h2 className="text-4xl font-bold text-slate-800 mb-3">{service.title}</h2>
                  <p className="text-lg text-emerald-600 font-semibold mb-4">{service.subtitle}</p>
                  <p className="text-slate-600 mb-6 leading-relaxed">{service.description}</p>
                  
                  <div className="space-y-4 mb-6">
                    <div className="flex items-start space-x-3">
                      <i className="ri-user-line text-emerald-600 mt-1"></i>
                      <div>
                        <p className="text-sm font-semibold text-slate-800">Perfil del Cliente</p>
                        <p className="text-sm text-slate-600">{service.profile}</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-money-dollar-circle-line text-emerald-600 mt-1"></i>
                      <div>
                        <p className="text-sm font-semibold text-slate-800">Montos</p>
                        <p className="text-sm text-slate-600">{service.amounts}</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-calendar-line text-emerald-600 mt-1"></i>
                      <div>
                        <p className="text-sm font-semibold text-slate-800">Plazos</p>
                        <p className="text-sm text-slate-600">{service.terms}</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-percent-line text-emerald-600 mt-1"></i>
                      <div>
                        <p className="text-sm font-semibold text-slate-800">Tasas</p>
                        <p className="text-sm text-slate-600">{service.rate}</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-slate-50 rounded-xl p-6 mb-6">
                    <h4 className="font-bold text-slate-800 mb-3">Requisitos Documentales</h4>
                    <ul className="space-y-2">
                      {service.requirements.map((req, idx) => (
                        <li key={idx} className="flex items-center text-sm text-slate-600">
                          <i className="ri-checkbox-circle-fill text-emerald-600 mr-2"></i>
                          {req}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-emerald-50 rounded-xl p-6 mb-6">
                    <h4 className="font-bold text-slate-800 mb-3">Proceso de Evaluación</h4>
                    <ol className="space-y-2">
                      {service.process.map((step, idx) => (
                        <li key={idx} className="flex items-start text-sm text-slate-600">
                          <span className="w-6 h-6 bg-emerald-600 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3 mt-0.5 flex-shrink-0">{idx + 1}</span>
                          {step}
                        </li>
                      ))}
                    </ol>
                  </div>

                  <p className="text-xs text-slate-500 italic mb-4">
                    * Sujeto a evaluación crediticia y cumplimiento de requisitos. Las tasas y condiciones pueden variar según el perfil del solicitante.
                  </p>

                  <Link to="/solicitar-credito" className="inline-block px-8 py-4 bg-emerald-600 text-white font-semibold rounded-lg hover:bg-emerald-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap">
                    Solicitar Este Crédito
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-24 bg-gradient-to-br from-slate-50 to-slate-100 rounded-2xl p-12 text-center">
            <h2 className="text-3xl font-bold text-slate-800 mb-4">¿No estás seguro cuál es el mejor para ti?</h2>
            <p className="text-slate-600 mb-8 max-w-2xl mx-auto">
              Nuestros asesores especializados pueden ayudarte a elegir la solución financiera más adecuada para tu situación
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link to="/contacto" className="px-8 py-4 bg-emerald-600 text-white font-semibold rounded-lg hover:bg-emerald-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap">
                Contactar un Asesor
              </Link>
              <Link to="/simulador" className="px-8 py-4 bg-white text-emerald-600 font-semibold rounded-lg hover:bg-slate-50 transition-all border border-emerald-600 whitespace-nowrap">
                Simular mi Crédito
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
